<template>
  <v-navigation-drawer
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    class="bg"
    clipped
    app
    light
    width="338"
  >
    <v-list>
      <!-- <DrawerItem icon="mdi-home" to="home" v-if="check_permission('home')"> home </DrawerItem> -->
      <DrawerItemHref
        icon="mdi-book-open-variant"
        to="https://www.reg.kmitl.ac.th/ebook/ManualAdmissionSystemRev1.pdf"
      >
        {{ $t("menu.application_documents_guide") }}
      </DrawerItemHref>

      <DrawerItem
        icon="mdi-card-search"
        to="undergraduate_explore"
        v-if="check_permission('undergraduate_explore')"
      >
        {{ $t("menu.explore_undergraduate") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-card-search"
        to="master_explore"
        v-if="check_permission('master_explore')"
      >
        {{ $t("menu.explore_master") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-card-search"
        to="phd_explore"
        v-if="check_permission('phd_explore')"
      >
        {{ $t("menu.explore_phd") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-bullhorn"
        to="undergraduate_announcement"
        v-if="check_permission('undergraduate_announcement')"
      >
        {{ $t("menu.announcement_undergraduate") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-bullhorn"
        to="graduate_announcement"
        v-if="check_permission('graduate_announcement')"
      >
        {{ $t("menu.announcement_graduate") }}
      </DrawerItem>

      <!-- --------------------------------------------------------- -->

      <v-divider
        color="white"
        v-if="check_permission('registered_program_list')"
      ></v-divider>

      <DrawerItem
        icon="mdi-clipboard-list"
        to="registered_program_list"
        v-if="check_permission('registered_program_list')"
      >
        {{ $t("menu.registered_program_list") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_general"
        v-if="
          check_permission('applicant_info_general') &&
            sidebar_status &&
            sidebar_status.user_info
        "
        :noti_badge="sidebar_status.user_info.passed === false"
      >
        {{ $t("menu.applicant_info_general") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_school"
        v-if="
          check_permission('applicant_info_school') &&
            sidebar_status &&
            sidebar_status.educational_background_ungrad
        "
        :noti_badge="sidebar_status.educational_background_ungrad.passed === false"
      >
        {{ $t("menu.applicant_info_school") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_university"
        v-if="
          check_permission('applicant_info_university') &&
            sidebar_status &&
            sidebar_status.educational_background_grad &&
            sidebar_status.educational_background_grad.required
        "
        :noti_badge="sidebar_status.educational_background_grad.passed === false"
      >
        {{ $t("menu.applicant_info_university") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_medicine"
        v-if="
          check_permission('applicant_info_medicine') &&
            sidebar_status &&
            sidebar_status.educational_background_medicine &&
            sidebar_status.educational_background_medicine.required
        "
        :noti_badge="sidebar_status.educational_background_medicine.passed === false"
      >
        {{ $t("menu.applicant_info_medicine") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_eng_inter"
        v-if="
          check_permission('applicant_info_eng_inter') &&
            sidebar_status &&
            sidebar_status.educational_background_inter &&
            sidebar_status.educational_background_inter.required
        "
        :noti_badge="sidebar_status.educational_background_inter.passed === false"
      >
        {{ $t("menu.applicant_info_eng_inter") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="applicant_info_constraints"
        v-if="
          check_permission('applicant_info_constraints') &&
            sidebar_status &&
            sidebar_status.constraint
        "
        :noti_badge="sidebar_status.constraint.passed === false"
      >
        {{ $t("menu.applicant_info_constraints") }}
      </DrawerItem>

      <v-divider color="white"></v-divider>

      <DrawerItem
        icon="mdi-comment-text-outline"
        to="questionnaire"
        v-if="check_permission('questionnaire')"
      >
        {{ $t("menu.questionnaire") }}
      </DrawerItem>
      <!-- --------------------------------------------------------- -->

      <v-divider
        color="white"
        v-if="check_permission('config_year')"
      ></v-divider>

      <DrawerItem
        icon="mdi-cog"
        to="config_year"
        v-if="check_permission('config_year')"
      >
        {{ $t("menu.config_year") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_round"
        v-if="check_permission('config_round')"
      >
        {{ $t("menu.config_round") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_project"
        v-if="check_permission('config_project')"
      >
        {{ $t("menu.config_project") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_project_group"
        v-if="check_permission('config_project_group')"
      >
        {{ $t("menu.config_project_group") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_curriculum"
        v-if="check_permission('config_curriculum')"
      >
        {{ $t("menu.config_curriculum") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_curriculum_constraint"
        v-if="check_permission('config_curriculum_constraint')"
      >
        {{ $t("menu.config_curriculum_constraint") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_master_reg_curriculum"
        v-if="check_permission('config_master_reg_curriculum')"
      >
        {{ $t("menu.config_master_reg_curriculum") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_faculty_bank_account"
        v-if="check_permission('config_faculty_bank_account')"
      >
        {{ $t("menu.config_faculty_bank_account") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-cog"
        to="config_faculty_officer_main"
        v-if="check_permission('config_faculty_officer_main')"
      >
        {{ $t("menu.config_faculty_officer_main") }}
      </DrawerItem>

      <!-- <DrawerItem
        icon="mdi-cog"
        to="config_curriculum_gat_pat"
        v-if="check_permission('config_curriculum_gat_pat')"
      >
        {{ $t("menu.config_curriculum_gat_pat") }}
      </DrawerItem> -->

      <DrawerItem
        icon="mdi-account-search"
        to="search_user"
        v-if="check_permission('search_user')"
      >
        {{ $t("menu.search_user") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-edit"
        to="move_applicant"
        v-if="check_permission('move_applicant')"
      >
        {{ $t("menu.move_applicant") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-account-arrow-left"
        to="gen_student_id"
        v-if="check_permission('gen_student_id')"
      >
        {{ $t("menu.gen_student_id_and_import_to_maticulation_system") }}
      </DrawerItem>
      <!-- -------------------------------------------------------- -->
      <v-divider
        color="white"
        v-if="check_permission('manual_for_executor')"
      ></v-divider>
      <DrawerItemHref
        icon="mdi-book-open-variant"
        to="https://www.reg.kmitl.ac.th/ebook/ManualAdmissionForExecutorLevel1.pdf"
        v-if="check_permission('manual_for_executor')"
      >
        {{ $t("menu.manual_admission_for_executor_level_1") }}
      </DrawerItemHref>
      <DrawerItemHref
        icon="mdi-book-open-variant"
        to="https://www.reg.kmitl.ac.th/ebook/ManualAdmissionForExecutorLevel2.pdf"
        v-if="check_permission('manual_for_executor')"
      >
        {{ $t("menu.manual_admission_for_executor_level_2") }}
      </DrawerItemHref>
      <!-- -------------------------------------------------------- -->
      <v-divider
        color="white"
        v-if="check_permission('number_of_applicants_report')"
      ></v-divider>

      <DrawerItem
        icon="mdi-file-document-multiple-outline"
        to="number_of_applicants_report"
        v-if="check_permission('number_of_applicants_report')"
      >
        {{ $t("menu.number_of_applicants_report") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-file-document-multiple-outline"
        to="number_of_applicants_by_order_report"
        v-if="check_permission('number_of_applicants_by_order_report')"
      >
        {{ $t("menu.number_of_applicants_by_order_report") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-file-document-multiple-outline"
        to="number_of_applicants_passed_report"
        v-if="check_permission('number_of_applicants_passed_report')"
      >
        {{ $t("menu.number_of_applicants_passed_report") }}
      </DrawerItem>

      <DrawerItem
        icon="mdi-file-document-alert-outline"
        to="not_paid_tuition_fee"
        v-if="check_permission('not_paid_tuition_fee')"
      >
        {{ $t("menu.not_paid_tuition_fee") }}
      </DrawerItem>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import DrawerItem from "./DrawerItem";
import DrawerItemHref from "./DrawerItemHref";
import { check_permission } from "@/router/acl";

export default {
  components: {
    DrawerItem,
    DrawerItemHref,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    check_permission,
  },
  computed: {
    sidebar_status() {
      return this.$store.state.auth.sidebar_status;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-heighlight {
  font-size: 20px;
  font-weight: bold;
}

.bg {
  background-color: rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(5px);
}
</style>
